import React, { useState, useEffect } from 'react';
import Modal from "../../components/molecules/Modal"
import InputLocation from "../atoms/InputLocation";
import {createAdminOrder, updateOrder} from "../../store/action/order";
import {isAuthenticated} from "../../store/action/auth";

const EditOrderForm = (props) => {
    const { token } = isAuthenticated();

    const [ order, setOrder ] = useState({
        destinationAddress:'',
        destinationCoordinate:{},
        destinationPostalCode:'',
        destinationNote:'',
        originAddress:'',
        originCoordinate:'',
        originPostalCode:''
    });
    const [ loading, setLoading ] = useState(false);

    const onLocationChange = (t,e) => {
        if (t === 'origin') {
            setOrder({
                ...order,
                originAddress:e
            })
        } else {
            setOrder({
                ...order,
                destinationAddress:e
            })
        }
    };

    const setLocation = (a,c,pc) => {
        setOrder({
            ...order,
            destinationAddress:a,
            destinationCoordinate:c,
            destinationPostalCode:pc
        })
    }

    const setOriginLocation = (a,c,pc) => {
        setOrder({
            ...order,
            originAddress:a,
            originCoordinate:c,
            originPostalCode:pc
        })
    }

    const onChange = name => e => {
        const {value} = e.target;
        setOrder({
            ...order,
            [name]: value
        });
    };

    const onUpdateOrder = async () => {
        await updateOrder(props.type,token,props.orderId,order)
            .then(data => {
                if(data.error) {
                   alert(data.error);
                   return
                }
                alert('Update order berhasil');
                window.location.reload()
            })
    }

    let content;
    if (props.type === 'admin') {
        content = (
            <div>
                <p>Masukkan lokasi penjemputan</p>
                <InputLocation
                    setLocation={(a,c,id,pc) => setOriginLocation(a,c,pc)}
                    placeholder={'Masukkan titik lokasi penjemputan'}
                    onLocationChange={e => onLocationChange('origin',e)}
                    value={order.originAddress}
                    loading={loading}
                />
                {order.originCoordinate ? `Kordinat terpasang : ${order.originCoordinate.latitude},${order.originCoordinate.longitude}`:null}
                <br/>
                {order.originPostalCode ? `Kodepos terpasang : ${order.originPostalCode}` : null}
            </div>
        )
    } else {
        content = (
            <div>
                <p>Informasi tambahan untuk order WooCommerce</p>
                <InputLocation
                    setLocation={(a,c,id,pc) => setLocation(a,c,pc)}
                    placeholder={'Masukkan titik lokasi penerima'}
                    onLocationChange={e => onLocationChange('destination',e)}
                    value={order.destinationAddress}
                    loading={loading}
                />
                <br/>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Catatan / Alamat penerima"
                    onChange={onChange('destinationNote')}
                    value={order.destinationNote}
                    required
                />
            </div>
        )
    }

    return (
        <Modal
            bodyClassName="p-4"
            buttons
            footerStyle={{justifyContent: 'space-between'}}
            headerClassName={"border-0"}
            loading={order.loading}
            onHide={props.onHide}
            show={props.show}
            size={'md'}
            title={"Edit Pesanan"}
            type={"oneButton"}
            bText={"Update Pesanan"}
            bClick={() => onUpdateOrder()}
        >
            {content}
        </Modal>
    )
};


export default EditOrderForm
